<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/13L1VOE/9780316232968.jpg?1733067604812" alt="This image is the cover for the book Grailblazers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Grailblazers
      </h1>
      <p class="bookDescription body article font2">
        <p>Fifteen hundred years have passed and the Holy Grail is still missing, presumed ineffable. The knights have dumped the quest and now deliver pizzas, while the sinister financial services of the lost kingdom of Atlantis threatens the universe with fiscal Armageddon.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tom Holt
      </h2>
      
      <p class="authorDescription body article"><B>Tom Holt</B> was born in London in 1961. At Oxford he studied bar billiards, ancient Greek agriculture and the care and feeding of small, temperamental Japanese motorcycle engines; interests which led him, perhaps inevitably, to qualify as a solicitor and emigrate to Somerset, where he specialized in death and taxes for seven years before going straight in 1995. He lives in Chard, Somerset, with his wife and daughter.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Orbit
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b65090fa